import { Box } from "@mui/joy";
import { AlbumWidget } from "../../../../components";

interface DesktopViewProps {
    imageGroups: any[];
    taskId: string;
    projectId: string;
}

export function DesktopView({ imageGroups, taskId, projectId }: DesktopViewProps) {
    return (
        <Box sx={{ mx: "auto", mt: 0 }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                {imageGroups.map((album: any) => (
                    <AlbumWidget key={album.id} {...album} taskId={taskId} projectId={projectId} />
                ))}
            </Box>
        </Box>
    );
}
